import { ComponentType } from 'react'
import { Contact } from './contact'
import { Intro } from './intro'

export const Promote: ComponentType = () => (
  <>
    <Intro />
    <Contact />
  </>
)
